/**
* Al envolver un componente React en la funcion withStyles de Material-UI
* las referencias se pasan mediante le parametro innerRef, no ref
*/
import React, {Component} from 'react';

class Button extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      buttonText,
      buttonTextclassName,
      buttonClass,
      buttonType,
      onClick,
      name,
      value,
      isStep3
    } = this.props;
    return (<button style={{
        display: isStep3 === 1
          ? "none"
          : ""
      }} value={value} name={name} type={buttonType} className={buttonClass} onClick={onClick}>
      <i className={buttonTextclassName}></i>{buttonText?' '+buttonText:''}
    </button>);
  }
}

export default Button;
